var _ellipse, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5001,
    cy: 19.0001,
    rx: 18.2843,
    ry: 18.5801,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9212 14.9133C18.9212 14.557 18.637 14.2682 18.2864 14.2682C17.9357 14.2682 17.6515 14.557 17.6515 14.9133V19.6444C17.6515 19.8759 17.7736 20.0896 17.9714 20.2045L20.9341 21.9249C21.2385 22.1017 21.6264 21.9942 21.8003 21.6848C21.9743 21.3755 21.8685 20.9814 21.5641 20.8046L18.9212 19.27V14.9133Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.498 9.53711C13.3554 9.53711 9.18652 13.7734 9.18652 18.9992C9.18652 24.225 13.3554 28.4613 18.498 28.4613C23.6406 28.4613 27.8094 24.225 27.8094 18.9992C27.8094 13.7734 23.6406 9.53711 18.498 9.53711ZM10.4563 18.9992C10.4563 14.486 14.0567 10.8274 18.498 10.8274C22.9393 10.8274 26.5397 14.486 26.5397 18.9992C26.5397 23.5124 22.9393 27.171 18.498 27.171C14.0567 27.171 10.4563 23.5124 10.4563 18.9992Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f5ad289b4a31992320d363048b71a8fa.svg";
export { ForwardRef as ReactComponent };